import React from 'react';
import i18n from '../../../i18n/i18n';
import axios from '../../../utils/AxiosWrapper';
import { Bar } from 'react-chartjs-2';
import 'react-dates/initialize';
import { formatData, formatForecast, formatDisease, formatWorkPlanningData } from '../DataFormatters';
import { withStyles } from '@material-ui/core/styles';
import { MoonLoader } from 'react-spinners';
import MeteoTable from '../MeteoTable';
import MeteoInfoButton from '../MeteoInfoButton';
import InfoSowingWindowCorn from '../Info/WorkPlanning/InfoSowingWindowCorn';

const styles = {
    value: { width: '8px', height: '8px', margin: '3px', borderRadius: '3px', padding: '8px', textAlign: 'center', fontWeight: 'bold', font: '12px', color: 'white' }
};

export class SowingWindowCorn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            station_id: this.props.row.uid,
            data: {},
            work: {},
            load: true,
            barColors: []
        };
    }

    componentDidMount() {
        this.getPessl();
    }

    getWork = (path, work) => {
        let obj = {};
        axios.post('/api/testMeteo/meteo', path)
            .then(res => {
                obj = formatWorkPlanningData(res, obj);
                this.setState({ [work]: obj });
                this.generateValuesAndColors();
            })
            .catch(err => console.log('Error: ', err))
    }

    getPessl = () => {
        let station_id = this.state.station_id;

        let work_path = '/forecast/' + station_id;

        this.getWork({ path: work_path, name: "sowing-window", crop: "corn", url: "https://api.fieldclimate.com/v2", method: "POST" }, 'work');
    }

    generateValuesAndColors() {
        let newValues = [];
        if (this.state.work['Sowing window']) newValues = this.state.work['Sowing window'].map(item => (item + 1));

        this.setState(prevState => {
            let work = { ...prevState.work };
            work['Sowing window'] = newValues;
            return { work }
        });

        let colors = [];
        for (let i = 0; i < this.state.work['Sowing window'].length; i++) {
            const element = this.state.work['Sowing window'][i];
            if (element === 1) {
                colors.push('#660000');
            } else if (element === 2) {
                colors.push('#C67465');
            } else {
                colors.push('#A1C16E');
            }
        }
        this.setState({ barColors: colors, load: false });
    }

    render() {
        console.log(this.state.work, this.state.barColors)
        const { classes } = this.props;

        let graph1 = {};
        let graph2 = {};

        const options1 = {
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
            tooltips: {
                displayColors: false,
                callbacks: {
                    label: (tooltipItem, chart) => graph1.datasets.map(ds => ds.label + ': ' + ds.data[tooltipItem.index]),
                },
            },
            scales: {
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 1,
                        gridLines: {
                            drawOnChartArea: false
                        },
                    },
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            drawOnChartArea: true
                        },
                        ticks: {
                            min: 0,
                            max: 3,
                            maxTicksLimit: 5
                        },
                    },
                ],
            },
        };
        const options2 = {
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-2',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[°C]'
                        },
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-3',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[mm]'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 4
                        }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-4',
                        gridLines: {
                            drawOnChartArea: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[%]'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 100,
                        }
                    }
                ],
            },
        };
        if (
            this.state.work.dates &&
            this.state.work
        ) {
            graph1 = {
                labels: this.state.work.dates,
                datasets: [
                    {
                        label: i18n.t('Precipitation [mm]'),
                        data: this.state.work['Precipitation'],
                        hidden: true,
                    },
                    {
                        label: i18n.t('Temperature [°C]'),
                        hidden: true,
                        data: this.state.work['Temperature']
                    },
                    {
                        label: i18n.t('Soil temperature [°C]'),
                        data: this.state.work['soiltemperature_0to10cm'],
                        hidden: true,
                    },
                    {
                        data: this.state.work['Sowing window'],
                        label: i18n.t('Value'),
                        backgroundColor: this.state.barColors,
                        type: 'bar',
                        borderWidth: 2,
                        yAxisID: 'y-axis-1',

                    },
                ],
            };

            graph2 = {
                labels: this.state.work.dates,
                datasets: [
                    {
                        data: this.state.work['Temperature'],
                        label: i18n.t('Temperature [°C]'),
                        backgroundColor: 'transparent',
                        borderColor: 'red',
                        type: 'line',
                        borderWidth: 2,
                        pointRadius: false,
                        yAxisID: 'y-axis-2',
                    },
                    {
                        data: this.state.work['Precipitation'],
                        label: i18n.t('Precipitation [mm]'),
                        backgroundColor: 'rgba(134,184,217,0.3)',
                        borderColor: '#86b8d9',
                        type: 'line',
                        borderWidth: 2,
                        pointRadius: false,
                        yAxisID: 'y-axis-3',
                    },
                    {
                        data: this.state.work['Probability of Prec.'],
                        label: i18n.t('Precipitation probability [%]'),
                        type: 'line',
                        backgroundColor: 'transparent',
                        borderColor: '#0d86d6',
                        borderWidth: 2,
                        pointRadius: false,
                        yAxisID: 'y-axis-4',
                        borderDash: [10, 5]
                    },

                ],
            };
        };

        return (
            <div style={{ paddingLeft: '35px' }}>
                <div style= {{display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                        <p style={{fontSize: 20, marginRight: 4 }}>{i18n.t('Conditions for sowing in the following period - corn')}</p>
                        </div>
                        <div style={{marginLeft: 20}}>
                        <MeteoInfoButton
                            title={i18n.t('Conditions for sowing in the following period - corn')}
                            text={<InfoSowingWindowCorn />}
                            height='400px'
                            width='sm'
                            />
                        </div>
                </div>
                {this.state.load === true && <div style={{ marginLeft: '39%', marginTop: '14%' }}> <MoonLoader loading={this.state.load} size={100} /></div>}
                {this.state.load === false &&
                    <div>
                        {/* <div>
                            <h1 align="center">{i18n.t('7 day forecast for sowing conditions - ')}{i18n.t('corn')}</h1>
                        </div> */}
                        <div style={{ marginTop: '30px', textAlign: "center" }}>
                            <span>{i18n.t('Very bad conditions - ')}</span>
                            <span className={classes.value} style={{ background: '#660000' }}>1</span>
                            <span className={classes.value} style={{ background: '#C67465' }}>2</span>
                            <span className={classes.value} style={{ background: '#A1C16E' }}>3</span>
                            <span>{i18n.t(' - very good conditions')}</span>
                        </div>
                        <div style={{ width: '95%', marginTop: '30px' }}>
                            <Bar data={graph1} height={300} width={600} options={options1} />
                        </div>
                        {/* <div style={{ width: '95%', marginTop: '20px'}}>
                            <Bar data={graph2} height={200} width={400} options={options2} />
                        </div> */}
                        <MeteoTable data={{
                            headers: [i18n.t('Date and time'), i18n.t('Temperature [°C]'), i18n.t('Precipitation [mm]'), i18n.t('Soil temperature [°C]')],
                            dates: this.state.work.dates,
                            temperature: this.state.work['Temperature'],
                            precipitation: this.state.work['Precipitation'],
                            soil: this.state.work['soiltemperature_0to10cm']
                        }} />
                        <div style={{ marginTop: '20px' }}></div>
                    </div>
                }
            </div>
        );
    }
};

export default withStyles(styles)(SowingWindowCorn);
